import curd from '../curd'

const BASE_PATH = '/profile/role'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/ProfileRole.js